export const projectTypesConstants = {
    RETRIEVE_PROJECT_TYPES: 'RETRIEVE_PROJECT_TYPES',
  }
  